import { createPutApiCall, createGetApiCall } from '../../Helpers/api'
import { isEmpty } from 'lodash'

export const getDesktopPropertiesRoute = '/api/rest/desktop/properties'
export const putDesktopPropertiesRoute = '/api/rest/desktop/properties'

const responseTransformer = data =>
  data.reduce(
    (objectifiedData, datum) => ({
      ...objectifiedData,
      [datum.name]: datum.value,
    }),
    {},
  )

const requestTransformer = request => Object.keys(request).map(name => ({ name, value: request[name] }))

export default {
  getDesktopProperties: (properties, tenantId) => {
    const parameters = {
      key: properties,
    }

    if (!isEmpty(tenantId)) {
      parameters.tid = tenantId
    }

    return createGetApiCall(getDesktopPropertiesRoute, responseTransformer)(parameters)
  },
  putDesktopProperties: properties => createPutApiCall(putDesktopPropertiesRoute)(requestTransformer(properties)),
}
